import { GlobalPositionStrategy } from '../core/overlay/position/global-position-strategy';

export class NotificationsPositionStrategy extends GlobalPositionStrategy {
  public apply(element: HTMLElement, zIndex: string): Promise<void | null> {
    return super.apply(element, zIndex).then(() => {
      element.style.justifyContent = this._justifyContent;
      element.style.alignItems = this._alignItems;
      element.style.display = 'flex';
      element.style.width = '100%';
      element.style.height = '100%';
    });
  }
}
